module.exports = __webpack_public_path__ + "img/home_bnews4_2.e16f7921.png";